var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M11.146 2.5H.862a.845.845 0 0 0-.479.146.871.871 0 0 0-.317.393.892.892 0 0 0 .188.957l5.142 5.25a.848.848 0 0 0 1.208 0l5.142-5.25a.892.892 0 0 0 .19-.953.872.872 0 0 0-.314-.394.845.845 0 0 0-.476-.149z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropDownDark);
export default __webpack_public_path__ + "static/media/icon-drop-down-dark.9f4cedd3145858bd64370067abcb3775.svg";
export { ForwardRef as ReactComponent };